import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        categoriesForm: '=',
        comparisonCategoriesForm: '=',
        questionCounter: '=',
        title: '=',
        compareTitle: '=',
        showIndividualAnswers: '='
    },
    template: `
    <div class="items09">
        <!--<h2>{{ 'survey.Results' | translate }}</h2>-->
        <div class="item"
            ng-repeat-start="category in vm.categoriesForm.categories"
            ng-init="comparisonCategory = vm.getCategory(category.name)">
            <h3>{{ category.name }}</h3>
        </div>
        <div class="item" ng-repeat="question in category.questions" ng-repeat-end>
            <survey-public-report-question-radio
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.RADIO"
                counter="vm.questionCounter[question.id]"
                question="question"
                compare-question="vm.getQuestion(comparisonCategory, question.id)"
                answers="vm.categoriesForm.answerOptions"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
            <survey-public-report-question-text
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                question="question" counter="vm.questionCounter[question.id]"
                compare-question="vm.getQuestion(comparisonCategory, question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
            <survey-public-report-question-scale
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
                question="question" counter="vm.questionCounter[question.id]"
                compare-question="vm.getQuestion(comparisonCategory, question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
                show-individual-answers="vm.showIndividualAnswers"
            />
            <survey-public-report-question-matrix
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.MATRIX"
                question="question" counter="vm.questionCounter[question.id]"
                compare-question="vm.getQuestion(comparisonCategory, question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
            <survey-public-report-question-checkbox
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX"
                question="question" counter="vm.questionCounter[question.id]"
                compare-question="vm.getQuestion(comparisonCategory, question.id)"
                title="vm.title"
                compare-title="vm.compareTitle"
            />
        </div>
    </div>
    `
})
export default class {
    constructor (QUESTIONS_TYPE_ENUM, lodash) {
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.lodash = lodash;
    }

    getCategory (name) {
        if (!this.comparisonCategoriesForm) {
            return 0;
        }
        return this.lodash.find(this.comparisonCategoriesForm.categories, { name });
    }

    getQuestion (category, id) {
        if (!category) {
            return 0;
        }
        return this.lodash.find(category.questions, { id });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/category/results/index.js